/**
 * /frontend/src/features/analytics/components/charts/GroupedBarChart.js
 */

import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

const resolveColor = (item, index) => item?.color || CHART_COLORS.series[index % CHART_COLORS.series.length];

/**
 * Grouped bar chart (clustered).
 * @param {{data:any[],xKey:string,bars:Array<{key:string,label:string,color?:string}>,height?:number,yFormatter?:(v:any)=>string}} props
 * @returns {JSX.Element}
 */
const GroupedBarChart = ({ data, xKey, bars, height, yFormatter }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <BarChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} tickFormatter={yFormatter} />
        <Tooltip formatter={yFormatter} />
        <Legend />
        {(bars || []).map((bar, index) => (
          <Bar
            key={bar.key}
            dataKey={bar.key}
            name={bar.label}
            fill={resolveColor(bar, index)}
            radius={[8, 8, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GroupedBarChart;
